"use client";

import AuthForm from "../../../../auth/AuthForm";
import StoreBox from "../store-box";

const AuthPage = (props) => {
  const { activateBackButton } = props;

  return (
    <>
      <StoreBox {...props} handleLocationChange={() => {}}>
        <div className="auth-container">
          <AuthForm
            defaultLogin={true}
            onBack={null}
            activateBackButton={activateBackButton}
          />
        </div>
      </StoreBox>
    </>
  );
};

export default AuthPage;
